import React from "react";
import ResetRequest from "../components/password-reset/PasswordResetRequest";

function PasswordResetScreen(props: { loginUrl: string; exitUrl: string }) {
  return (
    <div className="container-fluid bg-theme" style={{ height: "100vh" }}>
      <div className="row h-100">
        <div className="d-flex align-items-center justify-content-center">
          <div className="col-md-4 left-debug">&nbsp;</div>
          <div className="col-md-4">
            <ResetRequest loginUrl={props.loginUrl} exitUrl={props.exitUrl} />
          </div>
          <div className="col-md-4 right-debug">&nbsp;</div>
        </div>
      </div>
    </div>
  );
}

export default PasswordResetScreen;
